import { render, staticRenderFns } from "./MealItemsActions.vue?vue&type=template&id=08e5c3d1"
import script from "./MealItemsActions.vue?vue&type=script&lang=js"
export * from "./MealItemsActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports